import {
  categorySubCategories,
  EPublisherSolutionModel
} from 'common/contracts';
import {
  EEventCategories,
  EEventSubCategories,
  ELocalStorageKeys,
  Events
} from 'constants/enums';
import { localStorageUtil } from 'utils/localStorageUtil';

import { EPublisherEventValue, PublisherEventType } from '../Settings.types';

export const getCategoryAndSubCategory = (eventValue: EPublisherEventValue) => {
  const categoryEntry = Object.entries(Events).find(([_, keys]) =>
    keys.includes(eventValue)
  );
  const category = categoryEntry?.[0] || EEventCategories.NEW;
  const subCategory =
    categorySubCategories[category]?.[eventValue] ||
    EEventSubCategories.UNKNOWN;

  return { category, subCategory };
};

export const getEventOrderMap = (): Record<string, number> => {
  return Object.entries(categorySubCategories)
    .sort(([a], [b]) => (a === EEventCategories.PORTAL ? -1 : b === EEventCategories.PORTAL ? 1 : 0))
    .flatMap(([_, subCategories]) => Object.keys(subCategories))
    .reduce(
      (acc, key, i) => {
        acc[key] = i;
        return acc;
      },
      {} as Record<string, number>
    );
};

export const enrichAndOrderEvents = (
  events: PublisherEventType[] = [],
  eventOrderMap: Record<string, number>
): PublisherEventType[] => {
  return [...events]
    .map((event) => {
      const { category, subCategory } = getCategoryAndSubCategory(event.value);
      return { ...event, category, subCategory };
    })
    .sort(
      (a, b) =>
        (eventOrderMap[a.value] ?? Infinity) -
        (eventOrderMap[b.value] ?? Infinity)
    );
};

export const groupEventsByCategory = (
  events: PublisherEventType[],
  includeCheckoutOnly: boolean
): Record<string, PublisherEventType[]> => {
  return events.reduce(
    (acc, event) => {
      if (
        !includeCheckoutOnly ||
        event.category === EEventCategories.CHECKOUT
      ) {
        const category = event.category || EEventCategories.NEW;
        acc[category] = acc[category] || [];
        acc[category].push(event);
      }
      return acc;
    },
    {} as Record<string, PublisherEventType[]>
  );
};
